import { useLocation, useOutletContext } from "react-router-dom";
import PageTitle from "@/components/PageTitle";
import { JobsOutletContext } from "@/pages/_layouts/jobs/JobPostIndexLayout";
import ViewJobApplicants from "@/pages/_layouts/jobs/_components/ViewJobApplicants";
import ApplicantsPageSkeleton from "@/pages/_layouts/jobs/_components/ApplicantPageSkeleton";

export default function JobPostApplicants() {
  const location = useLocation();
  const { data, loading, title } = useOutletContext<JobsOutletContext>();

  if (loading && !data?.jobPost) {
    return <ApplicantsPageSkeleton />;
  }

  if (!data?.jobPost) return null;

  return (
    <>
      <PageTitle pattern={location.pathname} title={`${title} | Jobs | Job Post Applicants`} />
      <ViewJobApplicants jobPost={data.jobPost} />
    </>
  );
}
